import React from 'react';
import { useAuth } from '../context/AuthContext';

const NAV = [
  { id: 'dashboard',     label: 'Dashboard',     icon: 'home' },
  { id: 'classes',       label: 'Clases',        icon: 'classes' },
  { id: 'patients',      label: 'Pacientes',     icon: 'patients' },
  { id: 'subscriptions', label: 'Suscripciones', icon: 'subs' },
  { id: 'stats',         label: 'Estadísticas',  icon: 'stats' },
];

export default function Layout({ current, onNav, children }) {
  const { user, logout, textSize, toggleTextSize } = useAuth();

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--warm-white)' }}>
      {/* Sidebar */}
      <aside style={{
        width: 240, flexShrink: 0,
        background: 'var(--ink)', color: 'var(--sand)',
        padding: '36px 20px',
        display: 'flex', flexDirection: 'column',
        position: 'sticky', top: 0, height: '100vh',
      }}>
        <div style={{ marginBottom: 36 }}>
          <div style={{
            fontSize: 'calc(11px * var(--text-scale))',
            fontWeight: 600,
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            color: 'rgba(245,240,232,0.75)',
            marginBottom: 8,
          }}>
            Administración
          </div>
          <div style={{
            fontFamily: "'Noto Serif', serif",
            fontSize: 'calc(22px * var(--text-scale))',
            fontWeight: 600, lineHeight: 1.1,
          }}>
            Gimnasia<br />Consciente
          </div>
          <div style={{
            width: 24, height: 2, background: 'var(--earth)', marginTop: 12,
          }} />
        </div>

        <nav style={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
          {NAV.map(item => (
            <button
              key={item.id}
              onClick={() => onNav(item.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '12px 14px',
                background: current === item.id ? 'rgba(245,240,232,0.12)' : 'transparent',
                border: 'none',
                borderRadius: 4,
                color: current === item.id ? 'var(--sand)' : 'rgba(245,240,232,0.78)',
                fontSize: 'calc(14px * var(--text-scale))',
                fontWeight: current === item.id ? 600 : 500,
                letterSpacing: '0.02em',
                textAlign: 'left',
                transition: 'all 0.15s',
              }}
            >
              <NavIcon name={item.icon} />
              {item.label}
            </button>
          ))}
        </nav>

        <div style={{
          paddingTop: 16,
          borderTop: '1px solid rgba(245,240,232,0.15)',
          display: 'flex', flexDirection: 'column', gap: 12,
        }}>
          {/* Botón de tamaño de texto */}
          <button
            onClick={toggleTextSize}
            title="Cambiar tamaño del texto"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '10px 14px',
              background: 'rgba(245,240,232,0.06)',
              border: '1px solid rgba(245,240,232,0.18)',
              borderRadius: 4,
              color: 'rgba(245,240,232,0.9)',
              fontSize: 'calc(11px * var(--text-scale))',
              fontWeight: 600,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3 11V5h2v6M3 8h2M9 11V5h2c1 0 1.5.5 1.5 1.5S12 8 11 8H9M9 8l3.5 3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
              </svg>
              Texto
            </span>
            <span style={{
              fontSize: 'calc(10px * var(--text-scale))',
              padding: '2px 8px',
              background: 'rgba(245,240,232,0.12)',
              borderRadius: 10,
              letterSpacing: '0.06em',
            }}>
              {textSize === 'large' ? 'Grande' : 'Normal'}
            </span>
          </button>

          {/* User info + logout */}
          <div style={{
            fontSize: 'calc(13px * var(--text-scale))',
            color: 'rgba(245,240,232,0.78)',
          }}>
            <div style={{ marginBottom: 6, fontWeight: 500 }}>{user?.name}</div>
            <button onClick={logout} style={{
              background: 'none', border: 'none',
              color: 'rgba(245,240,232,0.6)',
              fontSize: 'calc(11px * var(--text-scale))',
              fontWeight: 600,
              letterSpacing: '0.16em',
              textTransform: 'uppercase',
              padding: 0,
            }}>
              Cerrar sesión
            </button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <main style={{ flex: 1, padding: '36px 48px', minWidth: 0 }}>
        {children}
      </main>
    </div>
  );
}

function NavIcon({ name }) {
  const props = { width: 18, height: 18, viewBox: '0 0 16 16', fill: 'none', stroke: 'currentColor', strokeWidth: 1.3, strokeLinecap: 'round', strokeLinejoin: 'round' };
  switch (name) {
    case 'home':
      return <svg {...props}><path d="M2 7l6-5 6 5v7H2z" /><path d="M6 14V9h4v5" /></svg>;
    case 'classes':
      return <svg {...props}><rect x="2" y="3" width="5" height="5" rx="1" /><rect x="9" y="3" width="5" height="5" rx="1" /><rect x="2" y="9" width="5" height="5" rx="1" /><rect x="9" y="9" width="5" height="5" rx="1" /></svg>;
    case 'patients':
      return <svg {...props}><circle cx="8" cy="5" r="3" /><path d="M2 14c0-3.3 2.7-6 6-6s6 2.7 6 6" /></svg>;
    case 'subs':
      return <svg {...props}><rect x="2" y="3" width="12" height="10" rx="1" /><line x1="2" y1="6" x2="14" y2="6" /><line x1="5" y1="10" x2="9" y2="10" /></svg>;
    case 'stats':
      return <svg {...props}><line x1="2" y1="14" x2="2" y2="2" /><line x1="2" y1="14" x2="14" y2="14" /><polyline points="4,11 7,7 10,9 13,4" /></svg>;
    default: return null;
  }
}
